module.exports = __webpack_public_path__ + "img/projectAdvantage-lazy.033be932.png";